import { LangStrings } from "@shapeable/ui";

export const LANG_STRINGS: LangStrings = { 
};